import log from 'salvo-lite/log'
import $ from 'jquery'

class BoxcleverTribe {
    constructor (theme, elem) {
        this._elem = elem
        this._elems = {
            'arrows': elem.querySelectorAll('.chevron-left, .chevron-right'),
            'cells': elem.querySelectorAll('.image__cell'),
            'thumbs': elem.querySelectorAll('.image--basic.block__image')
        }
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)
        this._onClick()
        this._initArrows()
    }

    _onClick () {
        let self = this
        let $cell = $('.image__cell')
        $cell.find('.image--basic').click(function () {
            let $thisCell = $(this).closest('.image__cell')
            if ($thisCell.hasClass('is-collapsed')) {
                $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed')
                $thisCell.removeClass('is-collapsed').addClass('is-expanded')
                let position = self._getPosition($(this), 25)
                window.scrollTo(0, position)
            } else {
                $thisCell.removeClass('is-expanded').addClass('is-collapsed')
            }
        })

        $cell.find('.expand__close').click(function () {
            let $thisCell = $(this).closest('.image__cell')
            $thisCell.removeClass('is-expanded').addClass('is-collapsed')
        })
    }

    _getPosition ($el, gutter) {
        let elOffset = $el.next().offset().top
        let elHeight = $el.next().outerHeight()
        let headerOffset = $('.header__wrap').outerHeight()
        let position = (elOffset + elHeight) - headerOffset - gutter
        return Math.ceil(position)
    }

    _initArrows () {
        for (let arrow of this._elems.arrows) {
            arrow.addEventListener('click', e => {
                let child = arrow.closest('.image__cell')
                let parent = child.parentNode
                let index = this._getIndex(child, parent)
                if (arrow.classList.contains('chevron-left')) {
                    let prevCell = this._elems.cells[index - 1]
                    if (prevCell) { prevCell.querySelector('.image--basic.block__image').click() }
                } else {
                    let nextCell = this._elems.cells[index + 1]
                    if (nextCell) { nextCell.querySelector('.image--basic.block__image').click() }
                }
            })
        }
    }

    _getIndex (child, parent) {
        return Array.prototype.indexOf.call(parent.children, child)
    }
}

export default BoxcleverTribe



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BoxcleverTribe.js